import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const ConfirmModal = ({
  show = false,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Yes",
  cancelText = "Cancel",
  confirmVariant = "danger",
  onConfirm,
  onCancel,
  loading= false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
    //   centered
      backdrop="static"
      aria-labelledby="confirm-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="confirm-modal-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{message}</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button disabled={loading} variant={confirmVariant} onClick={onConfirm}>
          {loading ? <Spinner size="sm" /> : confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
